import React from "react";
import { navigate } from "gatsby";
import { Deal } from "@ifgengineering/client-invest-sdk";
import { useSelector } from "react-redux";
import { useTheme } from "styled-components";
import { ThemedText } from "@components/ThemedText";
import { isWebV3IncomeFundEnabledSelector } from "@state/remoteConfiguration/remoteConfiguration.selectors";
import DealList from "../../deals/DealList";
import { LiveDealsV3 } from "@components/v3/live-deals";
import DotIcon from "@icon-park/react/es/icons/Dot";
import { ItemsCountContainer, SectionContainer } from "./styled";

interface IfIsaDealsSectionProps {
  deals: Deal[];
}

export const IfIsaDealsSection = ({ deals }: IfIsaDealsSectionProps) => {
  // Follows the V3 flag so this list always matches the live deals page:
  // V3 cards when the flag is on, the legacy list when it is off.
  const isWebV3IncomeFundEnabled = useSelector(
    isWebV3IncomeFundEnabledSelector
  );

  if (deals.length === 0) {
    return null;
  }

  return (
    <SectionContainer>
      <ItemsCount label="IF-ISA Live Deals" count={deals.length} />
      {isWebV3IncomeFundEnabled ? (
        <LiveDealsV3
          deals={deals}
          embedded
          onSelectDeal={(deal) =>
            navigate(`/app/deals/${deal.id}?referrer=ifisa`)
          }
          onSelectFund={(investableId) =>
            navigate(`/app/funds/${investableId}?referrer=ifisa`)
          }
        />
      ) : (
        <DealList deals={deals} referrer="ifisa" paddingBottom="0px" />
      )}
    </SectionContainer>
  );
};

export const ItemsCount = React.memo(
  ({ label, count }: { label: string; count: number }) => {
    const theme = useTheme();

    return (
      <ItemsCountContainer>
        <ThemedText type="H18" color="SLATE800">
          {label}{" "}
        </ThemedText>
        <DotIcon size={16} fill={theme.colors.ui.icon.disabled} />
        <ThemedText type="P18" color="SLATE600">
          {count}
        </ThemedText>
      </ItemsCountContainer>
    );
  }
);
ItemsCount.displayName = "ItemsCount";
